import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import CollectionForm from "components/form/CollectionForm";

import useCollectionForm from "hooks/form/useCollectionForm";

function ModificaCollezione() {
    const formCollectionHook = useCollectionForm();

    const { buttonUpdate } = formCollectionHook;

    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Modifica Collection</h1>
                </GridItem>
            </GridRow>

            <CollectionForm formCollectionHook={formCollectionHook} />

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={buttonUpdate}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </>
    );
}

export default ModificaCollezione;
